module.exports = __webpack_public_path__ + "e29d0b56626c78935e7357f268c3e46d.svg";


//////////////////
// WEBPACK FOOTER
// ./res/images/logo/logo_classica.svg
// module id = 422
// module chunks = 0